import { render, staticRenderFns } from "./ForeignOrganization.vue?vue&type=template&id=9d3a4ac0&"
import script from "./ForeignOrganization.vue?vue&type=script&lang=js&"
export * from "./ForeignOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports